export default {
  most_popular: '#{{rank}} mest populære',
};
